import type { IOption } from "@components/ui-kit";
import type { ModalTaskDependenciesQuery } from "@src/__generated__/graphql";
import mapToOptions from "@src/utils/map-to-options";
import { isTrackingEnabled } from "@src/utils/time-tracking";
import { useMemo } from "react";

export const useDependenciesOptions = (
  data: ModalTaskDependenciesQuery | undefined,
  spentTime: number | undefined,
) => {
  return useMemo(() => {
    const _options = {
      budgetItemOptions: [] as IOption[],
      workTypeOptions: [] as IOption[],
    };

    if (!data) return _options;

    _options.budgetItemOptions = mapToOptions.budgetItems(
      data.projectForTask?.ourWork ?? [],
      (option) => {
        if (!spentTime) return option;

        return {
          value: option.value,
          label: option.label,
          disabled: !isTrackingEnabled(
            data.projectForTask?.ourWork?.find((i) => i.id === option.value)
              ?.timeTrackingSettings ?? {},
          ),
        };
      },
    );
    _options.workTypeOptions = mapToOptions.toOptions(
      data.projectForTask?.availableTimeTrackingWorkTypes ?? [],
      "title",
    );

    return _options;
  }, [data, spentTime]);
};
